import { Select } from "@design";
import { useTranslation } from "react-i18next";
import { Text } from "@/components/Text";

export const RANGE_DAYS = ["7", "30", "90"] as const;
export type RangeDays = (typeof RANGE_DAYS)[number];
export const DEFAULT_RANGE: RangeDays = "30";

/** Start of the range as an ISO datetime at UTC midnight, so the query key is stable for the whole day. */
export function rangeStart(days: RangeDays, now: Date = new Date()): string {
  const start = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  start.setUTCDate(start.getUTCDate() - Number(days));
  return start.toISOString();
}

/** Labeled range picker ("AI usage range" / "Azure costs range"). */
export function RangeSelect({
  label,
  value,
  onChange,
}: Readonly<{ label: string; value: RangeDays; onChange: (value: RangeDays) => void }>) {
  const { t } = useTranslation("adminUsage");
  return (
    <div className="flex items-center gap-2">
      <Text as="span" variant="body-sm" tone="tertiary" className="shrink-0">
        {label}
      </Text>
      <div className="w-40">
        <Select
          size="sm"
          aria-label={label}
          value={value}
          options={RANGE_DAYS.map((days) => ({ value: days, label: t(`range.${days}`) }))}
          onChange={(next) => onChange(next as RangeDays)}
        />
      </div>
    </div>
  );
}
